import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Button, Classes, H5, HTMLTable, Popover } from "@blueprintjs/core";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { newIReceita } from "../../model";
import moment from "moment";
import { get15thDayOfNextMonth } from "../../utils";
import { DeiStore } from "../../stores/dei/DeiStore";
import { IconButton } from "@mui/material";
import { DaeAvulsoStore } from "../../stores/dae-avulso/DaeAvulsoStore";
import DeiPage from "./DeiPage";

const numeral = require("numeral");

interface Props {
  item: any
  onTransmitir?: () => void
  possuiImpostos: boolean;
}

@observer
export default class DeiTable extends React.Component<Props, {}> {
  static solicita_dei() {
    throw new Error("Method not implemented.");
  }

  obs = observable({
    apuracao: [] as any,
    impostos: [] as any,
    imposto_selecionado: "" as string,
  })

  constructor(props: any) {
    super(props);
  }

  onTreeStateChange = (state) => { }

  /**
 * Retorna uma sequência de espaços em branco HTML para ser usada como margem ou espaçamento visual no layout.
 * 
 * Esta função é útil quando você precisa de um espaçamento fixo no layout, representado por uma sequência de entidades HTML `&nbsp;` (não quebráveis), que são usadas para gerar espaços no conteúdo renderizado.
 * 
 * @returns {JSX.Element} Um elemento JSX contendo uma série de espaços não quebráveis (`&nbsp;`), que pode ser utilizado para criar uma margem visual ou espaçamento entre elementos.
 */
  marginItem() {
    return (<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>)
  }

  /**
 * Retorna uma sequência de espaços em branco HTML para ser usada como margem ou espaçamento visual no layout.
 * 
 * Esta função é útil quando você precisa de um espaçamento fixo no layout, representado por uma sequência de entidades HTML `&nbsp;` (não quebráveis), que são usadas para gerar espaços no conteúdo renderizado.
 * 
 * @returns {JSX.Element} Um elemento JSX contendo uma série de espaços não quebráveis (`&nbsp;`), que pode ser utilizado para criar uma margem visual ou espaçamento entre elementos.
 */
  marginSubitem() {
    return (<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>)
  }

  /**
 * Retorna uma linha vazia em formato de tabela, com células preparadas para espaçamento visual.
 * 
 * A função gera uma linha de tabela (`<tr>`) contendo quatro células (`<td>`), sendo a primeira célula preenchida com o caractere de espaço invisível Unicode (`\u200B`) e as outras três células vazias. 
 * Esta linha pode ser utilizada para criar espaçamentos ou margens dentro de uma tabela, sem exibir dados visíveis.
 * 
 * @returns {JSX.Element} Um elemento JSX representando uma linha de tabela vazia, com células vazias ou com conteúdo invisível.
 */
  rowEmpty() {

    return (<tr>
      <td>{"\u200B"}</td>
      <td></td>
      <td></td>
      <td></td>
    </tr>)

  }

  /**
 * Função chamada quando um nome é clicado, que realiza o processamento de dados relacionados ao ICMS, FCP, ou outros débitos e créditos.
 * 
 * A função executa os seguintes passos:
 * 1. Limpa o estado de `apuracao` e `imposto_selecionado` no objeto `this.obs`.
 * 2. Define o imposto selecionado com base no nome do nó (`nodeData.name`).
 * 3. Calcula o valor de ICMS (ou outro imposto relacionado) dependendo do campo do `nodeData` (ICMS, FCP ou 1139).
 * 4. Calcula o saldo total considerando os valores de débito e crédito.
 * 5. Preenche uma tabela com várias linhas, incluindo os totais de débito, crédito, e o saldo final.
 * 6. Adiciona valores e informações adicionais a partir do `nodeData.outros_debitos`, se existirem.
 * 7. Atualiza o estado `apuracao` com as linhas geradas para visualização.
 * 
 * A tabela gerada contém informações sobre:
 * - Total de produtos/receita.
 * - Total de débitos (com base em ICMS ou outros impostos).
 * - Total de créditos.
 * - Valor contestado.
 * - O saldo de ICMS a recolher ou o saldo credor de ICMS para o mês seguinte, dependendo do cálculo final.
 * 
 * @param {Object} nodeData Dados relacionados ao imposto, incluindo valores de ICMS, FCP, valores contestados e outros débitos.
 * 
 * @returns {void} Não retorna valor. A função altera o estado da aplicação atualizando a variável `apuracao` com os dados processados.
 */
  onNameClick = (nodeData) => {

    this.obs.apuracao = []
    this.obs.imposto_selecionado = ""

    this.obs.imposto_selecionado = nodeData.name

    const rows = []

    let icms = 0

    if (nodeData.campo == "ICMS") { icms = (nodeData.valor_icms || 0) }
    if (nodeData.campo == "FCP") { icms = (nodeData.valor_fcp || 0) }
    if (nodeData.campo == "1139") { icms = (nodeData.valor_1139 || 0) }

    let saldo_total = icms - (nodeData.valor_contestacao_icms || 0)

    rows.push(<tr>
      <td>Total produtos / receita</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(nodeData.valor || 0).format("0,0.00")}</td>
    </tr>)

    rows.push(this.rowEmpty())

    rows.push(<tr>
      <td>Total de débitos</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(icms || 0).format("0,0.00")}</td>
    </tr>)

    nodeData?.outros_debitos?.forEach(value => {

      rows.push(<tr>
        <td>{this.marginSubitem()}{value.nome}</td>
        <td className="valor-table-apuracao">{numeral(value.valor || 0).format("0,0.00")}</td>
        <td></td>
        <td></td>
      </tr>)

    })

    rows.push(this.rowEmpty())

    rows.push(<tr>
      <td>Total de créditos</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(nodeData.valor_contestacao_icms || 0).format("0,0.00")}</td>
    </tr>)

    rows.push(<tr>
      <td>{this.marginItem()}Valor Contestado</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(nodeData.valor_contestacao_icms || 0).format("0,0.00")}</td>
    </tr>)

    rows.push(this.rowEmpty())
    rows.push(this.rowEmpty())

    rows.push(<tr>
      <td><b>{saldo_total > 0 ? "ICMS a recolher" : "Saldo credor de ICMS para o mês seguinte"}</b></td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao"><b>{numeral(saldo_total || 0).format("0,0.00")}</b></td>
    </tr>)

    this.obs.apuracao = rows

  }

  /**
 * Prepara e configura os dados necessários para gerar um DAE (Documento de Arrecadação de Receitas) avulso.
 * 
 * A função realiza as seguintes ações:
 * 1. Cria uma nova receita, inicializando o objeto `DaeAvulsoStore.obs.receita` com valores padrão.
 * 2. Define a data de vencimento como o 15º dia do próximo mês, calculado com base no período de apuração atual.
 * 3. Define a data de cálculo como a data atual.
 * 4. Atribui o código de receita e o valor a ser pago com base no parâmetro `value` e o saldo total calculado.
 * 5. Define a data de referência do DAE com base no mês e ano do período de apuração.
 * 6. Atribui o CNPJ da empresa selecionada no `SpedApuracaoStore` à receita.
 * 7. Abre o formulário do DAE avulso para visualização ou preenchimento.
 * 
 * @param {Object} value O objeto contendo as informações do código de receita.
 * @param {number} saldo_total O valor total a ser pago, que será atribuído ao DAE.
 * 
 * @returns {void} Não retorna valor. A função apenas altera o estado de `DaeAvulsoStore` e configura os dados do DAE.
 */
  handleDae(value, saldo_total: number) {

    DeiStore.obs.receita = newIReceita()

    DeiStore.obs.date_vencimento = get15thDayOfNextMonth(moment(SpedApuracaoStore.obs.periodoDei[0]).toDate())
    DeiStore.obs.date_calculo = new Date()

    DeiStore.obs.receita.codigo_receita = value.codigo_receita;
    DeiStore.obs.receita.valor_pagar = Math.abs(saldo_total || 0);

    DeiStore.obs.receita.data_referencia = moment(SpedApuracaoStore.obs.periodoDei[0]).format("MM/YYYY");

    DeiStore.obs.receita.cnpj = SpedApuracaoStore.obs.selectedEmpresaDei.cnpj

  }

  /**
 * Verifica se o DAE (Documento de Arrecadação de Receitas) pode ser gerado com base nos valores do imposto, e retorna um botão de ação para gerar o DAE, se aplicável.
 * 
 * @param {Object} value O objeto contendo os valores e informações sobre o imposto (ICMS, FCP, ou 1139), valores contestados e se o DAE avulso pode ser gerado.
 * 
 * @returns {JSX.Element} Um componente JSX que renderiza um botão de ícone, que aciona a função de geração do DAE se as condições forem atendidas. Caso contrário, exibe um botão desabilitado.
 */
  valid_dei(value) {

    return (
      <IconButton disabled style={{ pointerEvents: "none" }}>{"\u200B"}</IconButton>
    )

  }

  /**
   * Prepara e envia uma solicitação de DAE/DEI com base nos valores de impostos apurados.
   * 
   * A função percorre os itens de impostos observados (`this.props.item`), calcula os saldos finais para cada tipo de imposto
   * (ICMS, FCP e 1139), e os organiza em um objeto de receitas.
   * Em seguida, utiliza o CNPJ da empresa selecionada e o período da apuração para montar os parâmetros
   * e chama a função `DeiStore.solicita_dei` para realizar a solicitação.
   * 
   * @returns {Promise<void>} Retorna uma `Promise` que se resolve após a solicitação ser enviada.
  */

  async solicita_dei() {
    const receitas = this.props.item.map(item => {
      let saldo_total = 0

      if (item.campo == "ICMS") saldo_total = ((item.valor_icms || 0) - (item.valor_contestacao_icms || 0))
      if (item.campo == "FCP") saldo_total = ((item.valor_fcp || 0) - (item.valor_contestacao_icms || 0))
      if (item.campo == "1139") saldo_total = ((item.valor_1139 || 0) - (item.valor_contestacao_icms || 0))

      return {
        [`${item.codigo_receita}`]: saldo_total
      };
    });

    const cnpj = SpedApuracaoStore.obs.selectedEmpresaDei.cnpj;
    const data_referencia = moment(SpedApuracaoStore.obs.periodoDei[0]).format("MM/YYYY");

    await DeiStore.solicita_dei({ cnpj, data_referencia, receitas });

    if (this.props.onTransmitir) {
      this.props.onTransmitir();
    }

    DaeAvulsoStore.obs.selectEmpresaDae = SpedApuracaoStore.obs.selectedEmpresaDei;

    const hoje = moment().format("YYYY-MM-DD");

    DaeAvulsoStore.obs.selectedPeriodDae = [new Date(), new Date()];

    await DaeAvulsoStore.handleDaePaged(1, SpedApuracaoStore.obs.selectedEmpresaDei.cnpj, hoje, hoje, "simples");

  }

  render() {

    return (
      <>
        <MDBRow>
          <MDBCol md="4" style={{ overflow: "auto", borderRight: "1px solid rgba(27, 99, 111, 0.15)", maxHeight: 500, minHeight: 100 }}>
            {this.props.possuiImpostos ?
              <>
                <div style={{ display: "block" }}>
                  <div style={{ float: "left", fontSize: 14, marginTop: 14 }}><b>IMPOSTOS</b></div>
                  <div style={{ float: "right", width: 50 }}>
                    <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position="right-bottom">
                      <IconButton className="icon-dae">
                        <img src="/images/arquivo_dei.png" width={50} />
                      </IconButton>
                      <div>
                        <H5>Confirmar transmissão?</H5>
                        <p style={{ fontSize: 11, textAlign: "justify" }}>
                          Ao transmitir o DEI, o sistema preencherá automaticamente os valores conforme os tributos informados.
                          <p>
                            <b> Para os tributos não especificados, os respectivos campos serão preenchidos com valor zero</b>.
                          </p>
                        </p>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                          <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                          <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.solicita_dei()}>Confirmar</Button>
                        </div>
                      </div>
                    </Popover>
                  </div>
                </div>

                {this.props.item.map(value => {

                  return (

                    <MDBBtn className={this.obs.imposto_selecionado == value.name ? "list-impostos list-impostos-selected" : "list-impostos"} onClick={() => this.onNameClick(value)}>

                      <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                        <span>{value.name}</span>

                        {this.valid_dei(value)}

                      </div>

                    </MDBBtn>)

                })}

              </>

              :

              <div style={{ display: "block" }}>
                <div style={{ float: "left", fontSize: 14, marginTop: 14 }}><b>Nenhum imposto encontrado!</b></div>
                <div style={{ float: "right", width: 50 }}>
                  <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position="right-bottom">
                    <IconButton className="icon-dae">
                      <img src="/images/arquivo_dei.png" width={50} />
                    </IconButton>
                    <div>
                      <H5>Confirmar transmissão?</H5>
                      <p style={{ fontSize: 11 }}>Você está transmitindo o DEI sem valores, o sistema irá zerar todos os impostos da declaração.</p>
                      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                        <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                        <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.solicita_dei()}>Confirmar</Button>
                      </div>
                    </div>
                  </Popover>
                </div>
              </div>
            }
          </MDBCol>

          <MDBCol md="8">

            {Object.keys(this.obs.apuracao).length ?

              <>
                <div style={{ fontSize: 14, textAlign: "center", marginBottom: 10 }}>
                  <b>IMPOSTO: {this.obs.imposto_selecionado}</b>
                </div>

                <HTMLTable className="table-hover " style={{ width: "100%" }} small striped>
                  <thead>
                    <tr>
                      <th style={{ borderRight: "1px solid rgba(27, 99, 111, 0.15)", width: "40%", textAlign: "center" }}>Descrição</th>
                      <th style={{ borderRight: "1px solid rgba(27, 99, 111, 0.15)", width: "20%", textAlign: "center" }}>Valor</th>
                      <th style={{ borderRight: "1px solid rgba(27, 99, 111, 0.15)", width: "20%", textAlign: "center" }}>Subtotal</th>
                      <th style={{ width: "20%", textAlign: "center" }}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.obs.apuracao}
                  </tbody>
                </HTMLTable>

              </>

              : <></>}

          </MDBCol>
        </MDBRow>

      </>
    )
  }
}